import { SurveyState } from './state';
import { SurveyAction, SurveyActions, SurveySetData, SurveySetAnswers } from './action';
import { deepclone } from '../../models/deepclone';
import { parseStringToInt } from '../../converter/stringConverter';

export const surveyInitial: SurveyState = {
    questions: [],
    answers: {},
};

export function surveyReducer(state: SurveyState = surveyInitial, action: SurveyActions) {
    switch (action.type) {
        case SurveyAction.SetData:
            const actSetData: SurveySetData = action as SurveySetData;
 
            return {
                ...state,
                questions: actSetData.value.questions,
                answers: actSetData.value.answers,
            };
        case SurveyAction.SetAnswers:
            const actSetAnswers: SurveySetAnswers = action as SurveySetAnswers;
            const currentAnswers = deepclone(state.answers);

            const keys = Object.keys(actSetAnswers.value.answers);
            keys.forEach((value) => {
                const id = parseStringToInt(value);
                currentAnswers[id] = actSetAnswers.value.answers[id];
            });

            return {
                ...state,
                answers: currentAnswers,
            };
      default:
        return state;
    }
}